/*
 * @Author: songxiaoqiang
 * @Date: 2020-09-21 17:49:46
 * @Last Modified by: songxiaoqiang
 * @Last Modified time: Do not edit
 * @Description:
 */
import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { LazyLoadImage } from 'react-lazy-load-image-component';
import axios from "axios/dist/axios.min.js";
import Request from '../../utils/request';
import utils from "../../utils/utils";
import "./style.less";

// 乐高页面类目和类目新人补贴类目对应关系
const CategoryNewcomer = {
  "鞋类": 1,
  "服饰": 2,
  "运动": 3,
  "数码": 4,
  "美妆": 5,
  "潮玩": 6,
  "配饰": 7,
  "手表": 8,
  "箱包": 9,
  "酒水": 10,
  "居家": 12,
  "/": 12,
  "母婴": 13,
  "宠物": 14,
  "营养保健": 15,
  "电器": 16,
  "个护": 17,
  "生活服务": 18
}

class PipelineIntelligent extends React.Component {
  constructor(props) {
    super(props);
    const { cardBaseConfig = {} } = props.config;
    const sortType = cardBaseConfig.sortType;
    // 初始化商品id列表数据
    const initList = [];
    this.initList = initList;
    this.state = {
      productList: initList,
      isFold: false,
      showPage: 1,
      pageSize: 0,
      visiable: false,
      mask_show: false,
      noticeVersionShow: false,
      backCount: 3,
      isCateNewUser: false,
      selectedItem: {},
      selectedIndex: ''
    };
    this.countDownInterVal = null;
    this.sortTypeMap = {
      '自定义排序': 0,
      '销量': 4,
      'GMV': 6,
      '上新时间': 8,
    };
    this.formTable = false;
    this.formType = '';
    this.page = 1;
    this.hasNext = true;
    this.isLoading = false;
    this.dataSourceConfig = {};  // 自定义表单数据源配置信息
    this.fieldMapTable = {};  // 当前选用的字段映射表
    this.initLayoutRowScroll = false;
    this.speed = utils.isAndroid() ? 0.5 : 1; // 滚动速度，每次增加的值
    this.scrollState = 'paused';
    this.scrollAnimation = null;
    this.isScrollEnd = false;
    this.delayTimeout = null;
    this.isAndroid = utils.isAndroid();
    this.author_name = utils.getQueryString('author_name') || '默认达人昵称';
    this.author_avatar = utils.getParams('author_avatar') || 'https://static.shihuocdn.cn/admin/files/20230613/68d710d769ea97e026852ea21ad3d2cd.png';
    this.style_ids = utils.getParams('style_ids') || '';
  }

  componentDidMount() {
    const verticals = window.classifyName
    this.getIfNewUser({verticals: CategoryNewcomer[verticals]})

    this.getProductListData();
  }

  getIfNewUser = (params) => {
    Request({
      url: 'https://sh-gateway.shihuo.cn/v4/services/sh-specialapi/activity/cate_new_status',
      method: "get",
      withCredentials: true,
      params: params,
    }).then(res => {
      const { status, data = {} } = res.data;
      if (status === 0) {
        this.setState({
          isCateNewUser: data.cate_new_user
        })
      }
    })
  }

  getProductListData() {
    let itemList = [];
    let { baseConfig, cardBaseConfig } = this.props.config;
    const sortType = baseConfig.sortType || (cardBaseConfig && cardBaseConfig.sortType);
    const shihuoSubsidy = baseConfig.shihuoSubsidy || (cardBaseConfig && cardBaseConfig.shihuoSubsidy);
    const productStyle = baseConfig.productStyle || (cardBaseConfig && cardBaseConfig.productStyle);

    if (sortType === '自定义排序') {
      itemList = JSON.parse(JSON.stringify(this.initList))
    } else {
      itemList = [];
    }
    const itemDataObj = {};
    let idList = this.style_ids ? this.style_ids.split(',') : [];
    idList = idList.map(item => {
      if (item) {
        return Number(item)
      }
    });

    let reqUrl = "", firstPageNum = 0, addBaseNum = 0;

    if (productStyle === '一行一个') {
      firstPageNum = 6;
      addBaseNum = 10;
    } else if (productStyle === '一行两个') {
      firstPageNum = 6;
      addBaseNum = 10;
    } else if (productStyle === '一行三个') {
      firstPageNum = 12;
      addBaseNum = 9;
    } else {
      firstPageNum = 0;
      addBaseNum = 0;
    }

    reqUrl =
        "https://sh-gateway.shihuo.cn/v4/services/sh-specialapi/style/info?access_token=znSnA7pxO35wtPBaur";
    
    Request({
      url: reqUrl,
      method: "post",
      withCredentials: true,
      data: {
        ids: idList,
        sort_tag: this.sortTypeMap[sortType] || 0,
        filter_subsidy: shihuoSubsidy === '是' ? 1 : 0,
        from: this.props.specialApiFrom
      },
    }).then((res) => {
      if (res.data.status === 0) {
       const list = res.data.data.List;
        if (sortType === '自定义排序') {
          itemList.forEach((item, index) => {
            if (item.id == '0') {
              // 无渠道商品，插入列表中
              const element = {
                id: item.id,
                image: item.productImageCustom,
                price: item.productPrice,
                title: item.name,
                url: item.productHref,
                useCustomName: item.useCustomName,
                title: item.name,
                recommendType: item.recommendType,
                shoppersLabel: item.shoppersLabel,
                recommend: item.recommend,
                custom_unitPrice: item.shoppersLabelText,
                image: item.productImageCustom,
                custom_markIcon: item.markIconCustom,
                custom_actionButton: item.actionButtonCustom,
              }
              list.splice(index, 0, element)
            }
          });
          // 插入定制化内容
          itemList.forEach((product) => {
            try {
              const customItem = list.find((item) => item.id == product.id);
              if (customItem && customItem.id != '0') {
                Object.assign(product, {
                  ...customItem,
                  image: (product.image && product.image.indexOf('8d9ebe0ba03eeade62495c93303d6de2') < 0) ? product.image : customItem.image,
                  title: customItem.title,
                  recommend: product.recommend || customItem.recommend,
                  custom_markIcon: product.markIconCustom,
                  custom_actionButton: product.actionButtonCustom,
                })
              }
            } catch (error) {
              const customItem_beta = itemDataObj[product.id];
              if (customItem_beta) {
                product.useCustomName = customItem_beta.useCustomName;
                product.title = customItem_beta.name;
                product.recommend = customItem_beta.recommend;
              }
            }
          });
          this.setState({
            visiable: true,
            productList: itemList,
            pageSize: Math.ceil((itemList.length - firstPageNum) / addBaseNum) + 1
          });
        } else {
          // 非自定义排序，以实时抓取的数据顺序展示
          itemList.forEach((item, index) => {
            if (item.id == '0') {
              // 无渠道商品，插入列表中
              const element = {
                id: item.id,
                image: item.productImageCustom,
                price: item.productPrice,
                title: item.name,
                url: item.productHref,
                useCustomName: item.useCustomName,
                title: item.name,
                recommendType: item.recommendType,
                shoppersLabel: item.shoppersLabel,
                recommend: item.recommend,
                custom_unitPrice: item.shoppersLabelText,
                image: item.productImageCustom,
                custom_markIcon: item.markIconCustom,
                custom_actionButton: item.actionButtonCustom,
              }
              list.splice(index, 0, element)
            }
          });
          // 插入定制化内容
          list.forEach((product) => {
            try {
              const customItem = itemList.find((item) => item.id == product.id);
              if (customItem && customItem.id != '0') {
                product.useCustomName = customItem.useCustomName;
                product.recommendType = customItem.recommendType;
                product.shoppersLabel = customItem.shoppersLabel;
                product.custom_unitPrice = customItem.shoppersLabelText;
                product.custom_markIcon = customItem.markIconCustom;
                product.custom_actionButton = customItem.actionButtonCustom;
                product.price = customItem.productPrice || product.price;
                product.url = customItem.productHref || product.url;
                product.title = customItem.useCustomName ? customItem.name : product.title;
                product.recommend = customItem.recommend || product.recommend;
                product.image = customItem.productImageCustom || product.image;
              }
            } catch (error) {
              console.log('商品组件数据遍历错误');
              const customItem_beta = itemDataObj[product.id];
              if (customItem_beta) {
                product.useCustomName = customItem_beta.useCustomName;
                product.title = customItem_beta.name;
                product.recommend = customItem_beta.recommend;
              }
            }
          });
          this.setState({
            visiable: true,
            productList: list,
            pageSize: Math.ceil((list.length - firstPageNum) / addBaseNum) + 1
          });
        }

        this.isLoading = false;
      }
    });
  }

  findKey (obj,value, compare = (a, b) => a === b) {
    return Object.keys(obj).find(k => compare(obj[k], value))
  }


  //判断版本号
  appVersion() {
    return  utils.SHDiffVersion(utils.getVersion(), '7.28.0')// 前面版本号大
  }

  linkClick() {
    const { isCateNewUser, selectedItem, selectetIndex } = this.state
    if ((isCateNewUser && !this.appVersion())) {
      if(utils.isAndroid()) {
        window.location.href = 'https://www.shihuo.cn/app3/download'
      } else {
        window.location.href = 'itms-apps://itunes.apple.com/app/id875177200?mt=8'
      }
      // window.Jockey.send("action", {
      //   url: "https://www.shihuo.cn/webview/upgrade?v=2.2#",
      // });
    } else {
      if (this.countDownInterVal) {
        clearInterval(this.countDownInterVal);
        this.countDownInterVal = null;
        this.setState({
          mask_show: false,
          noticeVersionShow: false,
          backCount: 3
        })
      }
      this.handleItemClick(selectedItem, selectetIndex)
    }
  }
  //新人类目价
  handleItemPerNewUserClick(item, index) {
    const { isCateNewUser } = this.state
    const { cardInfoConfig } = this.props.config
    if (cardInfoConfig.newUserPrice) {
      if (!isCateNewUser || (isCateNewUser && !this.appVersion())) {
        this.setState({
          mask_show: true,
          noticeVersionShow: true,
          selectedItem: item,
          selectetIndex: index,
          // backCount: 3
        })
      if (!isCateNewUser) {
        clearInterval(this.countDownInterVal);
        this.countDownInterVal = setInterval(() => {
          if (this.state.backCount <= 1) {
            clearInterval(this.countDownInterVal);
            this.countDownInterVal = null;
            this.setState({
              mask_show: false,
              noticeVersionShow: false,
              backCount: 3
            })
            this.handleItemClick(item, index)
          } else {
            this.setState({
              backCount: this.state.backCount - 1
            });
          }
        }, 1000);
      }
      } else {
        this.handleItemClick(item, index)
      }
    } else {
      this.handleItemClick(item, index)
    }
   
    
  }

  // 关闭弹窗
  closeNewUserDialog() {
    if (this.countDownInterVal) {
      clearInterval(this.countDownInterVal);
      this.countDownInterVal = null;
    }
    this.setState({
      mask_show: false,
      noticeVersionShow: false,
      backCount: 3
    })
  }

  handleItemClick(item, index) {
    if (this.props.templateName === 'toufang') {
      utils.handleToufangClick({
        link: item.url,
        props: this.props,
        index
      })
      return
    }
    const { baseConfig, cardBaseConfig } = this.props.config;
    const options = {
      title: baseConfig.title,
      type: baseConfig.productStyle || (cardBaseConfig && cardBaseConfig.productStyle),
      sort: index,
      name: item.title
    };
    if (baseConfig.productType === "商品id" || (cardBaseConfig && cardBaseConfig.productType === "商品id")) {
      options.goods_id = item.id;
    } else {
      options.style_id = item.id;
    }
    utils.jumpToUrl(this.props.routeParams,item.url,item.url,options,item.id,this.props);
  }

  productBannerGo = (url) => {
    if (this.props.templateName === 'toufang') {
      utils.handleToufangClick({
        link: url,
        props: this.props,
      })
      return
    }

    // 商品banner跳转
    const options = {};
    const convertUrl = utils.convertHref(url);
    utils.jumpToUrl(this.props.routeParams,convertUrl,url,options,-1,this.props,false);
  };

  handleExpandMore = () => {
    const { showPage, pageSize } = this.state;
    this.setState({
      showPage: showPage + 1 > pageSize ? 1 : showPage + 1
    });
  }

  render() {
    let { showPage, pageSize, visiable, mask_show, noticeVersionShow, backCount, isCateNewUser } = this.state;
    const { baseConfig, cardBaseConfig, cardInfoConfig } = this.props.config;

    if (cardBaseConfig.productStyle === "一行一个") {
      Object.assign(cardBaseConfig, cardBaseConfig.layout_1);
    } else if (cardBaseConfig.productStyle === "一行两个") {
      Object.assign(cardBaseConfig, cardBaseConfig.layout_2);
    } else if (cardBaseConfig.productStyle === "一行三个") {
      Object.assign(cardBaseConfig, cardBaseConfig.layout_3);
    } else if (cardBaseConfig.productStyle === "一行一排") {
      Object.assign(cardBaseConfig, cardBaseConfig.layout_row);
    }

    if (!visiable) {
      return (
        <div
          className="pipeline-intelligent"
          id={this.props['customAttributes']['data-component-id']}
          name={baseConfig.title}
          {...this.props['customAttributes']}
          style={{
            paddingTop: baseConfig.moduleMarginTop >= 0 ? `${baseConfig.moduleMarginTop}px` : 0,
            marginTop: baseConfig.moduleMarginTop < 0 ? `${baseConfig.moduleMarginTop}px` : 0,
            marginLeft: cardBaseConfig.productStyle != '一行一排' && `${cardBaseConfig.moduleMarginHorizon}px`,
            marginRight: cardBaseConfig.productStyle != '一行一排' &&`${cardBaseConfig.moduleMarginHorizon}px`,
            marginBottom: this.props.showCompMarginBottom ? '8px' : '0px',
          }}
        >
        </div>
      );
    }

    return (
      <div
        className="pipeline-intelligent"
        id={this.props['customAttributes']['data-component-id']}
        name={baseConfig.title}
        {...this.props['customAttributes']}
        style={{
          marginTop: `${cardBaseConfig.moduleMarginTop}px`,
          marginLeft: cardBaseConfig.productStyle != '一行一排' && `${cardBaseConfig.moduleMarginHorizon}px`,
          marginRight: cardBaseConfig.productStyle != '一行一排' && `${cardBaseConfig.moduleMarginHorizon}px`,
          marginBottom: this.props.showCompMarginBottom ? '8px' : '0px',
        }}
      >
        {
          ((baseConfig.showTitle && baseConfig.title) || (baseConfig.showSubTitle && baseConfig.subTitle)) && cardBaseConfig.productStyle !== "一行一排" && (
            <div className="title-area">
              {baseConfig.showTitle && baseConfig.title && ['一行一个', '一行两个', '一行三个'].indexOf(cardBaseConfig.productStyle) >= 0 && (
                <div className="title" style={{ color: baseConfig.titleColor }}>
                  {baseConfig.title.slice(0, 16)}
                </div>
              )}
              {baseConfig.showSubTitle && baseConfig.subTitle && ['一行一个', '一行两个', '一行三个'].indexOf(cardBaseConfig.productStyle) >= 0 && (
                <div
                  className="sub-title"
                  style={{ color: baseConfig.titleColor }}
                  dangerouslySetInnerHTML={{ __html: baseConfig.subTitle }}
                />
              )}
            </div>
          )
        }
        {cardBaseConfig.imgUrl && ['一行一个', '一行两个', '一行三个'].indexOf(cardBaseConfig.productStyle) >= 0 && (
          <img
            className="product-banner"
            onClick={this.productBannerGo.bind(this, cardBaseConfig.imgLink)}
            src={utils.formatImgUrl(cardBaseConfig.imgUrl, this.props.webpSupport)}
            alt=""
          />
        )}
        <div
          className="referral"
          style={{
            backgroundColor: cardBaseConfig.headBgColor,
            backgroundImage: `url(${cardBaseConfig.headBgImageUrl})`,
            backgroundSize: "100% 100%",
            backgroundRepeat: "no-repeat",
          }}
        >
          <div className="referral-avatar">
            <img src={this.author_avatar} alt="" />
          </div>
          <p className="referral-name" style={{ color: baseConfig.titleColor }}>{'@' + this.author_name}</p>
          <p className="referral-desc" style={{ color: baseConfig.titleColor }}>为你推荐</p>
        </div>
        {
          cardBaseConfig.productCardType !== '促销样式'
            ? this.renderNormalType()
            : this.renderPromotionType()
        }
        {
          baseConfig.showFoldBtn && (
            <div className="fold-btn" style={{color: baseConfig.titleColor, borderColor: baseConfig.titleColor ? this.hexColorToRgba(baseConfig.titleColor, 0.8) : baseConfig.titleColor}} onClick={() => this.handleExpandMore()}>
              {showPage >= pageSize ? '收起' : '展开更多'}
              {
                showPage >= pageSize ? (
                  <svg t="1664182775303" className="icon up" viewBox="0 0 1024 1024" version="1.1" xmlns="https://www.w3.org/2000/svg" p-id="2222"><path d="M169.344 694.656a32 32 0 0 0 40.832 3.648l4.48-3.648L512 397.248l297.344 297.408a32 32 0 0 0 40.832 3.648l4.48-3.648a32 32 0 0 0 3.648-40.832l-3.648-4.48-320-320a32 32 0 0 0-40.832-3.648l-4.48 3.648-320 320a32 32 0 0 0 0 45.312z" p-id="2223" fill={baseConfig.titleColor}></path></svg>
                ) : (
                  <svg t="1664182701343" className="icon down" viewBox="0 0 1024 1024" version="1.1" xmlns="https://www.w3.org/2000/svg" p-id="2002"><path d="M169.344 329.344a32 32 0 0 1 40.832-3.648l4.48 3.648L512 626.752l297.344-297.408a32 32 0 0 1 40.832-3.648l4.48 3.648a32 32 0 0 1 3.648 40.832l-3.648 4.48-320 320a32 32 0 0 1-40.832 3.648l-4.48-3.648-320-320a32 32 0 0 1 0-45.312z" p-id="2003" fill={baseConfig.titleColor}></path></svg>
                )
              }
            </div>
          )
        }
        { mask_show && <div className="pipeline-product-mask"></div> }
        {
          noticeVersionShow && (
            <div className={["pipeline-product-notice-version", `${!isCateNewUser ? "pipeline-product-notice-version2" : null}`].join(" ")}>
              <div className="pipeline-product-notice-version-title">{!isCateNewUser ? `活动仅限${window.classifyName}新用户`:'当前版本过低'}</div>
              {!isCateNewUser ? 
                 <div className="pipeline-product-notice-version-content">
                    <div>抱歉，你无法享受新人价</div>
                    <div>可继续查看全网底价</div>
                 </div> :
                 <div className="pipeline-product-notice-version-content">请升级最新版本，享受补贴</div>
              }
              <div className="pipeline-product-notice-version-button" onClick={this.linkClick.bind(this)}>{!isCateNewUser ? `去查看（${backCount}s）` : '去升级'}</div>
              <img
                  src="https://static.shihuocdn.cn/admin/files/20221226/ceab8c8de1a6373675898799f28e1e0d.png"
                  alt=""
                  className="pipeline-product-notice-version-close"
                  onClick={this.closeNewUserDialog.bind(this)}
                />
            </div>
          )
         
        }
      </div>
    );
  }

  // 常规样式
  renderNormalType() {
    let { productList = [], showPage, pageSize, visiable, mask_show, noticeVersionShow, backCount, isCateNewUser } = this.state;
    const { baseConfig, cardBaseConfig, cardInfoConfig } = this.props.config;

    const bodyWidth = typeof window !== "undefined" ? window.document.body.clientWidth : 375;
    // 判断不同布局方式下的间距取值
    Object.assign(cardBaseConfig, cardBaseConfig.layout_2);
      productList = productList;
    // 转为数字处理，后续参与计算
    cardBaseConfig.itemMargin = isNaN(Number(cardBaseConfig.itemMargin))
      ? 0
      : Number(cardBaseConfig.itemMargin);

    const remainder = productList.length % 2;
    
    return (
      <div className="product-list product-list-normal" style={{backgroundColor: cardBaseConfig.moduleBgColor}}>
        {productList.map((item, index) => {
          let rowItemNumber = 2; // 每行排列数量

          if (remainder != 0 && index === 0) {
            rowItemNumber = 1;
          } else {
            rowItemNumber = 2; // 每行排列数量
          }

          // 折扣计算
          let discountRate = item.price / item.original_price;
          if (
            discountRate > 1 ||
            isNaN(discountRate) ||
            item.original_price === 0
          ) {
            discountRate = 1;
          }
          discountRate = discountRate * 10;
          discountRate = parseFloat(discountRate.toFixed(1));

          // 行数计算
          const currentRowIndex = Math.floor(index / rowItemNumber) + 1;
          const totalRowNum = Math.ceil(productList.length / rowItemNumber);
          const isFirstRow = Boolean(currentRowIndex === 1); // 该项是否在首行
          const isLasthRow = Boolean(totalRowNum === currentRowIndex); // 该项是否在未行
          const isFirstColumn = Boolean(index % rowItemNumber === 0);
          const isLastColumn = Boolean((index + 1) % rowItemNumber === 0); // 该项是否在未列

          // 计算每个项的宽度
          const totalMargin = (rowItemNumber - 1) * cardBaseConfig.itemMargin;
          const itemWidth = `calc((100% - ${totalMargin}px) / ${rowItemNumber})`;
          const itemStyle = {
            width: itemWidth,
            backgroundColor: cardBaseConfig.cardBackgroundColor
          };

          if (!cardBaseConfig.cardBackgroundColor) {
            cardBaseConfig.cardBackground && Object.assign(itemStyle, {
              backgroundImage: `url(${cardBaseConfig.cardBackground})`,
              backgroundSize: "100% 100%",
              backgroundColor: "transparent",
              backgroundRepeat: "no-repeat",
              borderRadius: "inherit"
            })
          } else {
            Object.assign(itemStyle, {
              backgroundColor: cardBaseConfig.cardBackgroundColor
            })
          }

          let productItem;

          if (remainder != 0 && index === 0) {
            // 三个展示都存在时，隐藏销量
            if (
              (cardInfoConfig.originPrice || cardInfoConfig.discount) &&
              cardInfoConfig.saleNum &&
              cardInfoConfig.priceIcon
            ) {
              cardInfoConfig.saleNum = false;
            }
            productItem = (
              <div
                className="product-item row-one-item"
                key={index}
                style={itemStyle}
                onClick={this.handleItemPerNewUserClick.bind(this, item, index)}
              >
                <div className="product-img-panel">
                  <LazyLoadImage
                    width={108}
                    height={108}
                    placeholder={<span className="lazy-load-placeholder" style={{display: 'inline-block', width: 108, height: 108}}></span>}
                    src={utils.formatImgUrl(item.image, this.props.webpSupport)}
                  />
                </div>
                <div className="product-info">
                  <div className="info">
                    <div
                      className={cardInfoConfig.slogen && cardInfoConfig.unitPrice ? "name line-clamp-1" : "name"}
                      style={{ WebkitBoxOrient: "vertical", color: cardBaseConfig.productNameColor }}
                    >
                      {item.title}
                    </div>
                    {cardInfoConfig.slogen && (
                      <p className="tag" style={{ color: cardBaseConfig.productTagColor }}>
                        {item.recommend}
                      </p>
                    )}
                    {(item.shoppersLabel === '单位价格' && cardInfoConfig.unitPrice && item.unit_price_text) && (
                      <p className="unit-price" style={{ color: cardBaseConfig.productTagColor }}>
                        {item.unit_price_text}
                      </p>
                    )}
                    {(item.shoppersLabel === '自定义' && cardInfoConfig.unitPrice && item.custom_unitPrice) && (
                      <p className="unit-price" style={{ color: cardBaseConfig.productTagColor }}>
                        {item.custom_unitPrice}
                      </p>
                    )}
                  </div>
                  <div className="sale">
                    <div className="price-container">
                      {cardBaseConfig.priceIcon && (
                        <img
                          className="price-icon"
                          src={utils.formatImgUrl(cardBaseConfig.priceIcon, this.props.webpSupport)}
                        />
                      )}
                      {
                        item.price && !cardInfoConfig.newUserPrice && (
                          <div className="price" style={{color: baseConfig.priceColor}}>
                            <span className="rmb-icon">¥</span>
                            {item.price}
                          </div>
                        )
                      }
                      {
                        cardInfoConfig.newUserPrice && item.new_user_price && (
                          <div className="price" style={{color: baseConfig.priceColor}}>
                            <span className="rmb-icon">¥</span>
                            {item.new_user_price}
                          </div>
                        )
                      }
                      {cardInfoConfig.originPrice &&
                        item.original_price > item.price &&
                        item.original_price > 0 && (
                          <span className="origin-price" style={{color: baseConfig.priceInfoColor}}>
                            ¥{item.original_price}
                          </span>
                      )}
                      {!cardInfoConfig.originPrice && cardInfoConfig.discount && discountRate != 10 && (
                        <div className="discount" style={{color: baseConfig.priceInfoColor}}>{discountRate}折</div>
                      )}
                    </div>
                    {cardInfoConfig.saleNum && item.id && item.sell_point > 0 && (
                      <div className="num" style={{color: baseConfig.priceInfoColor}}>{item.sell_point_str.indexOf('W') < 0 ? item.sell_point_str : item.sell_point_str.replace('W', 'w')}人付款</div>
                    )}
                  </div>
                </div>
                {
                  cardInfoConfig.markIcon && (item.custom_markIcon || cardBaseConfig.markIcon) && (
                    <img className="mark-icon" src={utils.formatImgUrl(item.custom_markIcon || cardBaseConfig.markIcon, this.props.webpSupport)} />
                  )
                }
                {
                  cardInfoConfig.actionButton && (item.custom_actionButton || cardBaseConfig.actionButton) && (
                    <img className="action-button" src={utils.formatImgUrl(item.custom_actionButton || cardBaseConfig.actionButton, this.props.webpSupport)} />
                  )
                }
              </div>
            );
          } else {
            // 四个展示都存在是，隐藏销量
            if (
              (cardInfoConfig.originPrice || cardInfoConfig.discount) &&
              cardInfoConfig.saleNum &&
              cardBaseConfig.priceIcon
            ) {
              cardInfoConfig.saleNum = false;
            }
            // 计算一行二商品图片宽度
            const productImgWidth = (bodyWidth - Number(cardBaseConfig.moduleMarginHorizon) * 2 - Number(cardBaseConfig.itemMargin)) / 2 - 8;
            productItem = (
              <div
                className={(cardInfoConfig.slogen || cardInfoConfig.unitPrice) ? "product-item row-two-item has-benefit" : "product-item row-two-item no-benefit"}
                key={index}
                style={itemStyle}
                onClick={this.handleItemPerNewUserClick.bind(this, item, index)}
              >
                <div className="product-img-panel" style={{ marginTop: 4, marginBottom: 4, paddingLeft: 4, paddingRight: 4 }}>
                  <div className="img-wrap">
                    <LazyLoadImage
                      width={productImgWidth}
                      height={productImgWidth}
                      placeholder={<span className="lazy-load-placeholder" style={{display: 'inline-block', width: productImgWidth, height: productImgWidth}}></span>}
                      src={utils.formatImgUrl(item.image, this.props.webpSupport)}
                    />
                    {
                      item.beltImg && <img src={utils.formatImgUrl(item.beltImg, this.props.webpSupport)} alt="" className="beltImg" />
                    }
                  </div>
                </div>
                <div className="product-info">
                  <div className="info">
                    <div
                      className={cardInfoConfig.slogen && cardInfoConfig.unitPrice ? "name line-clamp-1" : "name"}
                      style={{ WebkitBoxOrient: "vertical", color: cardBaseConfig.productNameColor  }}
                    >
                      {item.title}
                    </div>
                    {cardInfoConfig.slogen && (
                      <div className="tag" style={{ color: cardBaseConfig.productTagColor }}>
                        {item.recommend}
                      </div>
                    )}
                    {(item.shoppersLabel === '单位价格' && cardInfoConfig.unitPrice && item.unit_price_text) && (
                      <p className="unit-price" style={{ color: cardBaseConfig.productTagColor }}>
                        {item.unit_price_text}
                      </p>
                    )}
                    {(item.shoppersLabel === '自定义' && cardInfoConfig.unitPrice && item.custom_unitPrice) && (
                      <p className="unit-price" style={{ color: cardBaseConfig.productTagColor }}>
                        {item.custom_unitPrice}
                      </p>
                    )}
                  </div>
                  <div className="sale">
                    <div className="price-container">
                      {cardBaseConfig.priceIcon && (
                        <img
                          className="price-icon"
                          src={utils.formatImgUrl(cardBaseConfig.priceIcon, this.props.webpSupport)}
                        />
                      )}
                      {
                        item.price && !cardInfoConfig.newUserPrice && (
                          <div className="price" style={{color: baseConfig.priceColor}}>
                            <span className="rmb-icon">¥</span>
                            {item.price}
                          </div>
                        )
                      }
                      {
                        cardInfoConfig.newUserPrice && item.new_user_price && (
                          <div className="price" style={{color: baseConfig.priceColor}}>
                            <span className="rmb-icon">¥</span>
                            {item.new_user_price}
                          </div>
                        )
                      }
                      {cardInfoConfig.originPrice &&
                        item.original_price > item.price &&
                        item.original_price > 0 && (
                          <span className="origin-price" style={{color: baseConfig.priceInfoColor}}>
                            ¥{item.original_price}
                          </span>
                      )}
                      {!cardInfoConfig.originPrice && cardInfoConfig.discount && discountRate != 10 && (
                        <div className="discount" style={{color: baseConfig.priceInfoColor}}>{discountRate}折</div>
                      )}
                    </div>
                    {cardInfoConfig.saleNum && item.id && item.sell_point > 0 && (
                      <div className="num" style={{color: baseConfig.priceInfoColor}}>{item.sell_point_str.indexOf('W') < 0 ? item.sell_point_str : item.sell_point_str.replace('W', 'w')}人付款</div>
                    )}
                  </div>
                </div>
                {cardInfoConfig.markIcon && (item.custom_markIcon || cardBaseConfig.markIcon) && (
                  <img className="mark-icon" src={utils.formatImgUrl(item.custom_markIcon || cardBaseConfig.markIcon, this.props.webpSupport)} />
                )}
              </div>
            );
          }
          
          return productItem;
        })}
      </div>
    )
  }

  // 促销样式
  renderPromotionType() {
    let { productList = [], showPage, pageSize, visiable, mask_show, noticeVersionShow, backCount, isCateNewUser } = this.state;
    const { baseConfig, cardBaseConfig, cardInfoConfig, promotionCardInfoConfig = {} } = this.props.config;

    const bodyWidth = typeof window !== "undefined" ? window.document.body.clientWidth : 375;
    // 判断不同布局方式下的间距取值
    Object.assign(cardBaseConfig, cardBaseConfig.layout_2);
    productList = baseConfig.showFoldBtn ? (showPage <= 1 ? productList.slice(0, 6) : productList.slice(0, 6 + 10 * (showPage - 1))) : productList;
    // 转为数字处理，后续参与计算
    cardBaseConfig.itemMargin = isNaN(Number(cardBaseConfig.itemMargin))
      ? 0
      : Number(cardBaseConfig.itemMargin);

    const remainder = productList.length % 2;

    return (
      <div className="product-list product-list-promotion" style={{backgroundColor: cardBaseConfig.moduleBgColor}}>
        {
          productList.map((item, index) => {
            let rowItemNumber = 2; // 每行排列数量
            
            if (remainder != 0 && index === 0) {
              rowItemNumber = 1;
            } else {
              rowItemNumber = 2; // 每行排列数量
            }
  
            // 折扣计算
            let discountRate = item.price / item.original_price;
            if (
              discountRate > 1 ||
              isNaN(discountRate) ||
              item.original_price === 0
            ) {
              discountRate = 1;
            }
            discountRate = discountRate * 10;
            discountRate = parseFloat(discountRate.toFixed(1));

            // 直降计算
            let plummet = 0;
            if (item.original_price && item.original_price > item.price) {
              plummet = Math.floor(item.original_price - item.price);
            }
  
            // 行数计算
            const currentRowIndex = Math.floor(index / rowItemNumber) + 1;
            const totalRowNum = Math.ceil(productList.length / rowItemNumber);
            const isFirstRow = Boolean(currentRowIndex === 1); // 该项是否在首行
            const isLasthRow = Boolean(totalRowNum === currentRowIndex); // 该项是否在未行
            const isFirstColumn = Boolean(index % rowItemNumber === 0);
            const isLastColumn = Boolean((index + 1) % rowItemNumber === 0); // 该项是否在未列

            // 是否展示销量
            const showSaleNum = promotionCardInfoConfig.saleNum && item.sell_point > 0;
  
            // 计算每个项的宽度
            const totalMargin = (rowItemNumber - 1) * cardBaseConfig.itemMargin;
            const itemWidth = `calc((100% - ${totalMargin}px) / ${rowItemNumber})`;
            const itemStyle = {
              width: itemWidth,
            };
  
            let productItem;
            if (remainder != 0 && index === 0) {
              productItem = (
                <div
                  className="product-item row-one-item"
                  key={index}
                  style={itemStyle}
                  onClick={this.handleItemPerNewUserClick.bind(this, item, index)}
                >
                  <div className="product-img-panel">
                    <LazyLoadImage
                      width={108}
                      height={108}
                      placeholder={<span className="lazy-load-placeholder" style={{display: 'inline-block', width: 108, height: 108}}></span>}
                      src={utils.formatImgUrl(item.image, this.props.webpSupport)}
                    />
                  </div>
                  <div className="product-info">
                    <div className="info">
                      <div
                        className={promotionCardInfoConfig.slogen && promotionCardInfoConfig.unitPrice ? "name line-clamp-1" : "name"}
                        style={{ WebkitBoxOrient: "vertical", color: cardBaseConfig.productNameColor }}
                      >
                        {item.title}
                      </div>
                      {promotionCardInfoConfig.slogen && (
                        <p className="tag" style={{ color: cardBaseConfig.productTagColor }}>
                          {item.recommend}
                        </p>
                      )}
                      {(promotionCardInfoConfig.unitPrice && item.shoppersLabel === '单位价格' && item.unit_price_text) && (
                        <p className="unit-price" style={{ color: cardBaseConfig.productTagColor }}>
                          {item.unit_price_text}
                        </p>
                      )}
                      {(promotionCardInfoConfig.unitPrice && item.shoppersLabel === '自定义' && item.custom_unitPrice) && (
                        <p className="unit-price" style={{ color: cardBaseConfig.productTagColor }}>
                          {item.custom_unitPrice}
                        </p>
                      )}
                    </div>
                    <div className="sale">
                      <div className="price-container">
                        {cardBaseConfig.priceIcon && (
                          <img
                            className="price-icon"
                            src={utils.formatImgUrl(cardBaseConfig.priceIcon, this.props.webpSupport)}
                          />
                        )}
                        {
                          item.price && !cardInfoConfig.newUserPrice && (
                            <div className={String(parseFloat(item.price)).length >= 5 ? 'price large' : 'price small'}>
                              <span className="rmb-icon">¥</span>
                              <p className={String(parseFloat(item.price)).length >= 5 ? 'large' : 'small'}>{item.price}</p>
                            </div>
                          )
                        }
                        {
                          cardInfoConfig.newUserPrice && item.new_user_price && (
                            <div className={String(parseFloat(item.price)).length >= 5 ? 'price large' : 'price small'}>
                              <span className="rmb-icon">¥</span>
                              <p className={String(parseFloat(item.price)).length >= 5 ? 'large' : 'small'}>{item.new_user_price}</p>
                            </div>
                          )
                        }
                        {
                          promotionCardInfoConfig.priceInfo === '原价' && (
                            <span className="origin-price" style={{textDecoration: (item.original_price > 0 && item.original_price != item.price) ? 'line-through' : 'none'}}>
                              {
                                (item.original_price 
                                  && item.original_price > 0
                                    && item.original_price != item.price)
                                      ? `¥${item.original_price}`
                                      : '爆款好价'
                                    }
                            </span>
                          )
                        }
                        {
                          promotionCardInfoConfig.priceInfo === '折扣' && (
                            <p className="discount">
                              {discountRate != 10 ? `${discountRate}折` : '爆款好价'}
                            </p>
                          )
                        }
                        {
                          promotionCardInfoConfig.priceInfo === '直降' && (
                            <p className="plummet">{plummet > 0 ? `直降¥${plummet}` : '爆款好价'}</p>
                          )
                        }
                      </div>
                      <div className="action-btn">
                        <p className={showSaleNum ? 'scramble show-sale-num' : 'scramble'}>抢</p>
                        {
                          showSaleNum && (
                            <p className="sale-num">
                              {item.sell_point_str.indexOf('W') < 0 ? item.sell_point_str : item.sell_point_str.replace('W', 'w')}人付款
                            </p>
                            )
                        }
                      </div>
                    </div>
                  </div>
                  {
                    promotionCardInfoConfig.markIcon 
                      && (item.custom_markIcon || cardBaseConfig.markIcon)
                        && (
                          <img className="mark-icon" src={utils.formatImgUrl(item.custom_markIcon || cardBaseConfig.markIcon, this.props.webpSupport)} />
                        )
                  }
                </div>
              );
            } else {
              // 计算一行二商品图片宽度
              const productImgWidth = (bodyWidth - Number(cardBaseConfig.moduleMarginHorizon) * 2 - Number(cardBaseConfig.itemMargin)) / 2 - 8;
              let priceExtra = '';

              if (promotionCardInfoConfig.priceInfo === '原价') {
                priceExtra = item.original_price > 0 && item.original_price != item.price && `¥${item.original_price}`;
              } else if (promotionCardInfoConfig.priceInfo === '折扣') {
                priceExtra = discountRate != 10 && `${discountRate}折`;
              } else if (promotionCardInfoConfig.priceInfo === '直降') {
                priceExtra = plummet > 0 && `直降¥${plummet}`;
              }

              if (item.hasOwnProperty('id') && !priceExtra) {
                priceExtra = '爆款好价'
              }

              productItem = (
                <div
                  className={ promotionCardInfoConfig.benefit !== "无" ? "product-item row-two-item has-benefit" : "product-item row-two-item no-benefit"}
                  key={index}
                  style={itemStyle}
                  onClick={this.handleItemPerNewUserClick.bind(this, item, index)}
                >
                  <div className="product-img-panel">
                    <div className="img-wrap">
                      <LazyLoadImage
                        width={productImgWidth}
                        height={productImgWidth}
                        placeholder={<span className="lazy-load-placeholder" style={{display: 'inline-block', width: productImgWidth, height: productImgWidth}}></span>}
                        src={utils.formatImgUrl(item.image, this.props.webpSupport)}
                      />
                      {
                        item.beltImg && <img src={utils.formatImgUrl(item.beltImg, this.props.webpSupport)} alt="" className="beltImg" />
                      }
                    </div>
                  </div>
                  <div className="product-info">
                    <div className="info">
                      <p
                        className={promotionCardInfoConfig.slogen && promotionCardInfoConfig.unitPrice ? "name line-clamp-1" : "name"}
                        style={{ WebkitBoxOrient: "vertical", color: cardBaseConfig.productNameColor  }}
                      >
                        {item.title}
                      </p>
                      {
                        promotionCardInfoConfig.benefit === '推荐理由' && (
                          <p className="tag" style={{ color: cardBaseConfig.productTagColor }}>
                            {item.recommend}
                          </p>
                        )
                      }
                      {
                        (
                          promotionCardInfoConfig.benefit === '单位价格'&& item.shoppersLabel === '单位价格' && item.unit_price_text) && (
                            <p className="unit-price" style={{ color: cardBaseConfig.productTagColor }}>
                              {item.unit_price_text}
                            </p>
                        )
                      }
                      {
                        (
                          promotionCardInfoConfig.benefit === '单位价格' && item.shoppersLabel === '自定义' && item.custom_unitPrice) && (
                            <p className="unit-price" style={{ color: cardBaseConfig.productTagColor }}>
                              {item.custom_unitPrice}
                            </p>
                        )
                      }
                    </div>
                    <div className="sale">
                      {
                        item.price && !cardInfoConfig.newUserPrice && (
                          <div className={String(parseFloat(item.price)).length >= 5 ? 'price large' : 'price small'}>
                            <span className="rmb-icon">¥</span>
                            <p className={String(parseFloat(item.price)).length >= 5 ? 'large' : 'small'}>{item.price}</p>
                          </div>
                        )
                      }
                      {
                        cardInfoConfig.newUserPrice && item.new_user_price && (
                          <p className="price">
                            <span className="rmb-icon">¥</span>
                            {item.new_user_price}
                          </p>
                        )
                      }
                      <p
                        className="origin-price"
                        style={{
                          textDecoration: 'none'
                        }}
                      >
                        {priceExtra}
                      </p>
                      {
                        item.sell_point > 0 && (
                          <p className="num">
                            {item.sell_point_str.indexOf('W') < 0 ? item.sell_point_str : item.sell_point_str.replace('W', 'w')}人付款
                          </p>
                        )
                      }
                    </div>
                  </div>
                  {
                    promotionCardInfoConfig.markIcon 
                      && (item.custom_markIcon || cardBaseConfig.markIcon) 
                        && (
                          <img className="mark-icon" src={utils.formatImgUrl(item.custom_markIcon || cardBaseConfig.markIcon, this.props.webpSupport)} />
                        )
                  }
                </div>
              );
            }

            return productItem;
          })
        }
      </div>
    )
  }

  hexColorToRgba(hexColor, opacity) {
    const alphaMaxVal = 1
    hexColor = hexColor.replace("#", "");
  
    //用于分割16进制色彩通道
    let reg = new RegExp("\\w{1,2}", "g");
    //分割颜色通道
    let rgbaArray255 = hexColor.match(reg);
    rgbaArray255 = rgbaArray255 && rgbaArray255.map((channel, index) => {
      //计算每个通道的10进制值
      let colorVal = parseInt(channel, 16);
      if (index === 3) {
        //这是alpha通道
        return Math.round(colorVal / (255 / alphaMaxVal) * 100) / 100
      }
      return colorVal;
    });
    return `rgb(${rgbaArray255.join(',')},${opacity})`;
  }
}

PipelineIntelligent.propTypes = {
  config: PropTypes.object.isRequired,
};

export { PipelineIntelligent };
export default PipelineIntelligent;



// WEBPACK FOOTER //
// ./components/pipeline-intelligent/index.js